import { render, staticRenderFns } from "./pay.vue?vue&type=template&id=1f9e3186&scoped=true"
import script from "./pay.vue?vue&type=script&lang=js"
export * from "./pay.vue?vue&type=script&lang=js"
import style0 from "../../style/common-pc.scss?vue&type=style&index=0&id=1f9e3186&prod&lang=scss&scoped=true&external"
import style1 from "./pay.vue?vue&type=style&index=1&id=1f9e3186&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../content-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9e3186",
  null
  
)

export default component.exports